import axios from 'axios';
import conf, { wxAppInfo } from '@/config';
import { Message } from 'element-ui';
import router from '@/router';
import { base64_encode } from 'ourwill-feutil/common/base64';

const NODE_ENV = process.env.NODE_ENV;

const ssoUrlLogin = conf.ssoPath + '/login?service=';

const login = (res) => {
	const { currentRoute } = router;
	// 报名表填写页面的401页面单独处理
	if (currentRoute && currentRoute.name === 'questionnaireVote') {
		return;
	}
	if(res) {
        const data = res.data;
        Message.error({
            message: data.msg ? data.msg : data.toString(),
        });
    }

	setTimeout(() => {
		if (conf.env === 'business') {
			window.location.href = location.pathname + '/#/login';
		} else {
			window.location.href = ssoUrlLogin + encodeURI(`${conf.host}/questionnaire/#/`);
		}
	}, 500);
};

const errors = (err) => {
	const msg = err.code === 'ECONNABORTED' ? '网络超时，请刷新重试' : err.msg || err.message || err.toString();
	Message.error({
		message: msg,
	});
	console.error(err);

	if (err.response) {
		if (err.response.status === 401) {
			login(err.response);
		}
		if (err.response.data) {
			Message.error({
				message: err.response.data.msg,
			});
		}
	}
	return err.response;
};

const filter = (res) => {
	const { status, data } = res;
	if (status >= 200 && status < 300) {
		if (data.code === 0 || data.status === 0) {
			res.ok = true;
			return res;
		} else if (data.code == 401) {
			login(res);
			res.ok = false;
			return res;
		} else if (typeof data === 'string') {
			return res;
		}
	}
	errors(data);
	res.ok = false;
	return res;
};

const httpCreate = (baseUrl, timeout = 600e3) => {
	const http = axios.create({
		baseURL: conf.host + baseUrl,
		timeout,
		headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
	});
	http.interceptors.response.use(filter, errors);
	return http;
};
const url = (path) => {
	return `${conf.host}/api/${path}`;
};

const urlfull = (path) => {
	return `${conf.host}${conf.surveyApipath}${path}`;
};

const wxauth = () => {
	const redirect_uri = encodeURIComponent(wxAppInfo.redirect_uri);
	const uri64 = base64_encode(location.href);
	// 2023-11-29改动，state参数太长会导致授权失败，state参数挪到redirect_uri后面
	const redirectUriStr = redirect_uri + (uri64 ? encodeURIComponent('?rState=' + uri64) : '');
	const loginUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppInfo.appid}&redirect_uri=${redirectUriStr}&response_type=code&scope=${wxAppInfo.scope}&forcePopup=true&#wechat_redirect`;
	// console.log('login url', loginUrl);
	location.href = loginUrl;
};

// 必须在客户端调用此函数
const preferVal = () => {
	return location.host === 'm.inmuu.com' ? 'third' : 'secretonly';
};

export { login, errors, filter, httpCreate, urlfull, url, wxauth, ssoUrlLogin, preferVal };
